import * as yup from "yup";

export const codesSchema = yup.object().shape({
  prefex: yup
    .string()
    .matches(/^[a-zA-Z0-9]{3}$/, "Prefix must be 3 alphanumeric characters")
    .required("Prefix is required"),

  quantity: yup
    .number()
    .typeError("Quantity must be a number")
    .positive("Quantity must be greater than 0")
    .integer("Quantity must be an integer")
    .max(1000, "Maximum quantity is 1000 code")
    .required("Quantity is required"),

  price: yup
    .number()
    .typeError("Price must be a number")
    .min(0, "Price must be greater than or equal to 0")
    .required("Price is required"),

  packageId: yup.string().required("Please select a package"),

  courierName: yup
    .string()
    .matches(/^[a-zA-Z].*/, "Please, Enter a valid courier name")
    .min(3, "Minimum is 3 characters")
    .max(30, "Maximum is 30 characters")
    .required("Please, Enter courier name"),

  bonus: yup
    .number()
    .nullable()
    .transform((value, originalValue) => {
      // Convert empty strings to null
      return originalValue === "" ? null : value;
    })
    .typeError("Please, Enter a valid bonus")
    .positive("Bonus must be a positive number")
    .notRequired(),

  // bonus: yup
  //   .number()
  //   .typeError("Please, Enter a valid bonus")
  //   .positive("Bonus must be a positive number")
  //   .notRequired(),

  status: yup.boolean().default(true), // Defaults to true (active)
});

const notificationObject = {
  titleEn: yup
    .string()
    // .matches(/^[A-Za-z ]+$/, "Please, Enter a valid title")
    .matches(/^[\w\s\p{P}\p{S}]+$/u, "Please, Enter a valid title")
    .min(3, "Minimum length is 3 chars")
    .max(30, "Maximum length is 30 chars")
    .required("Please, Enter the title"),
  titleAr: yup
    .string()
    // .matches(/^[\u0600-\u06FF ]+$/, "Please, Enter a valid title")
    .matches(/^[\u0600-\u06FF\s\p{P}\p{S}]+$/u, "Please, Enter a valid title")
    .min(3, "Minimum length is 3 chars")
    .max(30, "Maximum length is 30 chars")
    .required("Please, Enter the title"),
  messageEn: yup
    .string()
    // .matches(/^[A-Za-z0-9 .,!?]+$/, "Please, Enter a valid content")
    .matches(/^[\w\s\p{P}\p{S}]+$/u, "Please, Enter a valid content")
    .min(3, "Minimum length is 3 chars")
    .max(100, "Maximum length is 100 chars")
    .required("Please, Enter the content"),
  messageAr: yup
    .string()
    // .matches(/^[\u0600-\u06FF .,!?]+$/, "Please, Enter a valid content")
    .matches(/^[\u0600-\u06FF\s\p{P}\p{S}]+$/u, "Please, Enter a valid content")
    .min(3, "Minimum length is 3 chars")
    .max(100, "Maximum length is 100 chars")
    .required("Please, Enter the content"),
  userType: yup.string().required("Please select recipients"),
  isSendNow: yup.boolean().required(),
};

// Yup Validation Schema
export const notificationsSchema = yup
  .object()
  .shape({ ...notificationObject });

export const notificationsSchemaWithData = yup.object().shape({
  ...notificationObject,
  scheduleTime: yup.string().required("Please, Select the date"),
});

export const headerSchema = yup.object().shape({
  title: yup.string().required("Please provide title"),
  categoryId: yup.string().required("Please select category"),
  imgPath: yup.string().required("Please upload an image"),
  partsCast: yup.array().of(
    yup
      .object()
      .shape({
        partId: yup.string().required("Please select part"),
        castIds: yup.array().of(yup.string().required("Please select casts")),
      })
      .test("unique", "Part should be unique", (value) => {
        const seen = new Set();
        return Array.isArray(value)
          ? value.every((part) => {
              if (seen.has(part.partId)) {
                return false;
              }
              seen.add(part.partId);
              return true;
            })
          : true;
      })
  ),
  isSeries: yup.boolean(),
  genreId: yup.string(),
});
